export class LegacySideNavItemModel {
    icon?: string;
    items?: LegacySideNavItemModel[];
    name: string;
    routeUrl?: string;
    appUrl?: string;
    queryParams?: any;
    roles?: string[];
    isSelected?: boolean;

    // Note why we have a legacy model:
    // For the legacy layout, we need to pass along the application id in the legacy layout to get the nav item route.
    // The newer nav in the header uses Array<HhsgSharedUserApplication> so it has this ID and childApplicationUserId is looked up.
    applicationId?: number;
    childApplicationUserId?: number;
    onlyShowOnCompactScreen?: boolean;
    hideOnCompactScreen?: boolean;
}
